exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sdr-custom-tab-active[data-v-344dc422]{color:#ab3b7a!important}.sdr-custom-tabs .v-item-group[data-v-344dc422]{padding-left:0}", ""]);

// exports
